import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Field, Form } from 'react-final-form';
import { Col } from 'react-bootstrap';
import {
  Card, CardBody, CardTitleWrap,
} from '@/shared/components/Card';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import renderRadioButtonField from '@/shared/components/form/RadioButton';
import {
  FormButtonToolbar,
  FormContainer,
  FormGroup,
  FormGroupField,
  FormGroupLabel,
  FormHalfContainer,
} from '@/shared/components/form/FormElements';
import { Button } from '@/shared/components/Button';
import PaxDetailsCard from './PaxDetailsCard';

const AddTrip = ({ onSubmit, disableButton }) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const onFormSubmit = async (values) => {
    setIsButtonDisabled(true); // Disable button after click
    await onSubmit(values); // Call the parent onSubmit function
    setIsButtonDisabled(false); // Enable button again if needed (e.g., after some delay or upon completion)
  };

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <CardTitleWrap>
            <p><span style={{ color: 'red' }}>*</span> Mark Fields are required.</p>
          </CardTitleWrap>
          <Form onSubmit={onFormSubmit}>
            {({ handleSubmit }) => (
              <FormContainer onSubmit={handleSubmit}>
                <FormHalfContainer>
                  <FormGroup>
                    <FormGroupLabel>Trip Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="tripname"
                        component="input"
                        type="text"
                        placeholder="Trip Name"
                        required
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup>
                    <FormGroupLabel>Ref no<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="ref_no"
                        component="input"
                        type="text"
                        placeholder="Reference no"
                        required
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup
                    className="col-md-12"
                    style={{
                    display: 'flex',
                  }}
                  >
                    <div className="col-md-6">
                      <FormGroupLabel>
                        Start Date <span style={{ color: 'red' }}>*</span>
                      </FormGroupLabel>
                      <FormGroupField>
                        <div>
                          <Field name="startDate">
                            {({ input }) => (
                              <DatePicker
                                {...input}
                                selected={input.value || null} // Ensure null if no date is selected
                                onChange={date => input.onChange(date)} // Update form value on date change
                                dateFormat="dd-MM-yyyy"
                                minDate={new Date(new Date().setDate(new Date().getDate() + 1))} // today + 1
                                placeholderText="Select Start Date"
                              />
            )}
                          </Field>
                        </div>
                      </FormGroupField>
                    </div>
                    <div className="col-md-6">
                      <FormGroupLabel>
                        End Date <span style={{ color: 'red' }}>*</span>
                      </FormGroupLabel>
                      <FormGroupField>
                        <div>
                          <Field name="endDate">
                            {({ input }) => (
                              <DatePicker
                                {...input}
                                selected={input.value || null} // Ensure null if no date is selected
                                onChange={date => input.onChange(date)} // Update form value on date change
                                dateFormat="dd-MM-yyyy"
                                minDate={new Date(new Date().setDate(new Date().getDate() + 1))} // today + 1
                                placeholderText="Select End Date"
                              />
            )}
                          </Field>
                        </div>
                      </FormGroupField>
                    </div>
                       
                  </FormGroup>
                 

                  <FormGroup>
                    <FormGroupLabel>Trip Type <span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="triptype"
                        component={renderRadioButtonField}
                        label="Group"
                        radioValue="1"
                      />
                      <Field
                        name="triptype"
                        component={renderRadioButtonField}
                        label="Family"
                        radioValue="2"
                      />
                    </FormGroupField>
                  </FormGroup>
                </FormHalfContainer>
                <FormHalfContainer>
                  <h4>
                    Pax Details
                  </h4>
                  <PaxDetailsCard />
                </FormHalfContainer>

                <FormButtonToolbar>
                  {/* <Button variant="danger" disabled={isButtonDisabled} type="button">
                    Close
                  </Button> */}
                  <Button variant="primary" disabled={isButtonDisabled} type="submit">
                    Add Trip
                  </Button>
                </FormButtonToolbar>
              </FormContainer>
            )}
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

AddTrip.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  disableButton: PropTypes.bool.isRequired,
};

export default React.memo(AddTrip);
